<template>
  <transition
    enter-active-class="tw-transition-opacity tw-duration-200"
    leave-active-class="tw-transition-opacity tw-duration-200"
    enter-class="tw-opacity-0"
    enter-to-class="tw-opacity-100"
    leave-class="tw-opacity-100"
    leave-to-class="tw-opacity-0"
  >
    <div
      v-show="userInfoVisible"
      class="tw-shadow-[0_6px_12px_0_rgba(0,0,0,0.1),0_-1px_1px_0_rgba(0,0,0,0.05)] tw-absolute tw-flex tw-flex-col tw-gap-[15px] tw-text-[12px] tw-z-[51] tw-top-[68px] tw-right-[26px] tw-bg-white tw-w-[320px] tw-rounded-[5px] tw-px-[20px] tw-py-[30px] tw-text-forText"
    >
      <div class="tw-flex tw-gap-[10px] tw-items-center tw-border-0">
        <div class="tw-flex tw-flex-col tw-items-center">
          <div
            class="tw-border-[1px] tw-border-solid tw-border-[#BDF300] tw-rounded-full tw-w-[42px] tw-h-[42px] tw-flex tw-items-center tw-justify-center tw-bg-main"
          >
            <img
              v-if="aboutUser.employee_is_admin"
              :src="require(`@/assets/header-icons/a.svg`)"
              class=""
            />
            <img
              v-if="!aboutUser.employee_is_admin"
              :src="require(`@/assets/header-icons/user.svg`)"
              class=""
            />
          </div>
          <img
            :src="require(`@/assets/header-icons/pro.svg`)"
            class="tw-h-[12px] tw-mt-[-7px]"
          />
        </div>
        <div>
          <div class="tw-text-forTitle tw-text-[15px]">
            {{ aboutUser?.employee_name }}
          </div>
          <div>{{ aboutUser?.jobtitle_name }}</div>
        </div>
      </div>

      <!-- Информация по сириус про -->
      <div
        class="tw-bg-[#EEF9F0] tw-justify-between tw-items-center tw-rounded-[5px] tw-text-[#23B14D] tw-border-[1px] tw-border-solid tw-border-[#DCE0ED]"
      >
        <div
          @click="siriusProInfoVisible = !siriusProInfoVisible"
          class="tw-flex tw-justify-between tw-items-center tw-py-[12px] tw-px-[10px] tw-cursor-pointer"
        >
          <div class="tw-text-[12px] tw-leading-[14px]">
            Ваш тариф - Сириус PRO
          </div>
          <img
            :src="require(`@/assets/header-icons/arrow-green.svg`)"
            class="tw-h-[5px] tw-duration-300"
            :class="siriusProInfoVisible ? 'tw-rotate-180 tw-transform' : ''"
          />
        </div>

        <div
          class="tw-grid tw-overflow-hidden tw-transition-[grid-template-rows] tw-duration-300 tw-ease-in-out"
          :class="
            siriusProInfoVisible ? 'tw-grid-rows-[1fr]' : 'tw-grid-rows-[0fr]'
          "
        >
          <div class="tw-min-h-0">
            <div class="tw-px-[10px] tw-pb-[10px]">
              <div
                class="tw-flex tw-gap-[8px] tw-items-center tw-mb-[5px]"
                v-for="i in [
                  `Профессиональные инструменты`,
                  `Расширенная автоматизация`,
                  `Детальная аналитика`,
                  `Дополнительные настройки`,
                  `Приоритетное обслуживание`,
                ]"
              >
                <img
                  :src="require(`@/assets/header-icons/checked-green.svg`)"
                />
                <div
                  class="tw-text-black tw-text-[10px] tw-leading-[12px]"
                >
                  {{ i }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Информация по сириус про -->

      <!-- <div class="tw-bg-forLine tw-h-[1px]"></div> -->

      <div>
        <div>Лицевой счет компании (SID)</div>
        <div
          class="tw-flex tw-justify-between tw-items-center tw-text-[20px] tw-text-forTitle tw-font-bold"
        >
          <div class="tw-flex tw-gap-[10px]">
            {{ userSetting?.company_lc }}
            <img
              title="Требует подтверждения"
              v-if="
                userSetting?.company_status == 'company_status_not_requested'
              "
              :src="require(`@/assets/status-zapros.svg`)"
              class="tw-w-[18px]"
            />
            <img
              v-if="userSetting?.company_status == 'company_status_confirmed'"
              title="Подтверждено"
              :src="require(`@/assets/header-icons/check.svg`)"
              class="tw-w-[18px]"
            />
            <img
              title="Отклонено"
              v-if="userSetting?.company_status == 'company_status_rejected'"
              :src="require(`@/assets/status-reject.svg`)"
              class="tw-w-[18px]"
            />
            <img
              title="На проверке"
              v-if="userSetting?.company_status == 'company_status_requested'"
              :src="require(`@/assets/status-time.svg`)"
              class="tw-w-[18px]"
            />
          </div>
          <img
            @click="onCopy(userSetting?.company_lc)"
            :src="require(`@/assets/header-icons/copy.svg`)"
            class="tw-w-[24px] tw-cursor-pointer"
          />
        </div>
      </div>

      <div class="tw-bg-forLine tw-h-[1px]"></div>

      <!-- Поддержка -->
      <div
        class="tw-bg-main2 tw-justify-between tw-items-center tw-rounded-[5px]"
      >
        <div
          @click="supportVisible = !supportVisible"
          class="tw-flex tw-justify-between tw-items-center tw-py-[12px] tw-px-[15px] tw-cursor-pointer"
        >
          <div class="tw-flex tw-gap-[10px]">
            <img
              :src="require(`@/assets/header-icons/support-white.svg`)"
              class="tw-w-[20px]"
            />
            <div class="tw-text-[15px] tw-text-white">Поддержка</div>
          </div>
          <img
            :src="require(`@/assets/header-icons/arrow-white.svg`)"
            class="tw-h-[5px] tw-duration-300"
            :class="supportVisible ? 'tw-rotate-180 tw-transform' : ''"
          />
        </div>

        <div
          class="tw-grid tw-overflow-hidden tw-transition-[grid-template-rows] tw-duration-300 tw-ease-in-out"
          :class="supportVisible ? 'tw-grid-rows-[1fr]' : 'tw-grid-rows-[0fr]'"
        >
          <div class="tw-min-h-0">
            <div
              class="tw-bg-white tw-border-[1px] tw-border-solid tw-border-forLine tw-rounded-[5px]"
            >
              <div
                class="tw-flex tw-gap-[10px] tw-py-[15px] tw-px-[10px] tw-border-0 tw-border-b-[1px] tw-border-solid tw-border-forLine"
              >
                <div
                  class="tw-bg-forLine tw-flex tw-justify-center tw-rounded-full tw-w-[32px] tw-h-[32px]"
                >
                  <img
                    :src="require(`@/assets/header-icons/letter.svg`)"
                    class="tw-w-[13px]"
                  />
                </div>
                <div>
                  <div class="tw-text-forTitle tw-font-bold">Напишите нам</div>
                  <div class="tw-text-[10px] tw-text-forText">
                    Ответим от 10 минут до 24 часов
                  </div>
                  <a
                    href="mailto:support@sirius.rent"
                    class="tw-block tw-text-[14px] !tw-text-[#0056AF] tw-mb-[2px] hover:tw-underline"
                  >
                    support@sirius.rent
                  </a>
                  <div class="tw-text-[10px]">
                    <span class="tw-text-forText">Укажите ваш SID:</span>
                    <span class="tw-text-forTitle">
                      {{ userSetting?.company_lc }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="tw-flex tw-gap-[10px] tw-py-[15px] tw-px-[10px]">
                <div
                  class="tw-bg-cream tw-flex tw-justify-center tw-rounded-full tw-w-[32px] tw-h-[32px]"
                >
                  <img
                    :src="require(`@/assets/header-icons/phone.svg`)"
                    class="tw-w-[14px]"
                  />
                </div>
                <div>
                  <div class="tw-text-forTitle tw-font-bold">
                    Срочная поддержка
                  </div>
                  <div class="tw-text-[10px] tw-text-forText">
                    Ежедневно с 9:00 до 19:00 МСК
                  </div>
                  <a
                    href="tel:84951465030,999"
                    class="tw-block tw-text-[15px] !tw-text-[#0056AF] tw-mt-[3px]"
                  >
                    +7 (495) 146-50-30
                    <span class="tw-text-[12px]"> (доб. 999) </span>
                  </a>
                </div>
              </div>

              <router-link
                :to="{ path: '/academy' }"
                class="tw-bg-[#F1F3F5] tw-flex tw-items-center tw-justify-between tw-gap-[10px] tw-py-[15px] tw-px-[10px] tw-group"
              >
                <div
                  class="tw-bg-forLine tw-flex tw-justify-center tw-rounded-full tw-w-[32px] tw-h-[32px]"
                >
                  <img
                    :src="require(`@/assets/header-icons/book.svg`)"
                    class="tw-w-[13px]"
                  />
                </div>
                <div class="tw-grow">
                  <div class="tw-text-forTitle tw-font-bold tw-leading-[14px]">
                    Большинство вопросов<br />уже есть в разделе
                  </div>
                  <div
                    class="tw-text-[15px] !tw-text-[#0056AF] tw-mt-[5px] group-hover:tw-underline"
                  >
                    Обучение №615
                  </div>
                </div>
                <img
                  :src="require(`@/assets/header-icons/arrow.svg`)"
                  class="tw-h-[5px] tw-rotate-[-90deg] tw-transform"
                />
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- Поддержка -->

      <div class="tw-bg-bgPage tw-py-[12px] tw-px-[15px] tw-rounded-[5px]">
        <router-link
          :to="{ path: '/clients/white' }"
          class="tw-block !tw-text-forText hover:tw-underline"
        >
          Изменить профиль - 201
        </router-link>
        <router-link
          :to="{ path: '/employees' }"
          class="tw-block !tw-text-forText hover:tw-underline"
        >
          Изменить видимость - 705
        </router-link>
      </div>

      <a
        href="#"
        @click.prevent="signOut"
        class="!tw-text-danger tw-flex tw-gap-[10px] tw-items-center hover:tw-underline"
      >
        Выйти из системы
        <img
          :src="require(`@/assets/header-icons/logout.svg`)"
          class="tw-h-[13px]"
        />
      </a>
    </div>
  </transition>
</template>

<script>
export default {
  props: ["aboutUser", "userSetting", "userInfoVisible"],
  data() {
    return {
      supportVisible: false,
      siriusProInfoVisible: false,
    };
  },
  methods: {
    async onCopy(text) {
      if (!navigator.clipboard) {
        console.error("Буфер обмена недоступен в этом браузере.");
        return;
      }
      try {
        await navigator.clipboard.writeText(text);
        this.$toast.info("SID скопирован");
      } catch (err) {
        this.$toast.error("Ошибка при копировании", { duration: 5000 });
      }
    },
    signOut() {
      localStorage.removeItem("user-token");
      localStorage.removeItem("translations");
      localStorage.removeItem("loginAt");
      this.$router.push("/auth");
    },
  },
};
</script>
